import React from 'react';
import PropTypes from 'prop-types';
import { Button, Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

function SecondaryButton({
  text,
  to,
  icon = <ArrowForwardIosIcon fontSize="small" />,
  fullWidth = false,
  tooltip = '',
}) {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(to);
  };

  return (
    <Tooltip title={tooltip}>
      <Button
        component="a"
        href={to}
        variant="outlined"
        onClick={(e) => {
          e.preventDefault();
          handleClick();
        }}
        fullWidth={fullWidth}
        color="secondary"
        sx={{
          textTransform: 'none',
          p: 1.5,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 1,
          borderRadius: '12px',
          fontFamily: 'inherit',
          fontSize: '16px',
          fontWeight: 500,
          transition: 'all 0.3s ease',
          textDecoration: 'none',
        }}
      >
        {text}
        {icon}
      </Button>
    </Tooltip>
  );
}

SecondaryButton.propTypes = {
  text: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  icon: PropTypes.element,
  fullWidth: PropTypes.bool,
  tooltip: PropTypes.string,
};

export default SecondaryButton;
